import React, { useState, useEffect, useRef } from "react";
import * as _ from "lodash";
import "../AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead } from "../ShareFunctionsPrint";
import HeaderDev from "./A4/HeadDev";
import FooterDev from "./A4/FooterDev";
import BodyDev from "./A4/BodyDev";

function HeadersNew(props) {
    const { locInv, found, sta} = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderDev found={found} sta={sta} locInv={locInv} />
        </div>
    );
}
function BodyInvoice(props) {
    const { chunk } = props;
    return (
        <div style={stylePadding}>
            <BodyDev
                data={chunk ?? []}
            />
        </div>
    );
}

function Footers(props) {
    const { inv } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterDev inv={inv} />
        </div>
    );
}

function DeleveryNotesPrint(props) {
    const { locInv, found, sta, inv, data } = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const max_Height = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 20);
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);

            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                if (currentHeight + rowHieght > max_Height) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight  > max_Height) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);
    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew found={found} sta={sta} locInv={locInv} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowRefs.current[i] = el)}
                        className="measurerow2"
                    >
                        {item.notesall}
                    </div>
                ))}
                <div ref={footerRef}>
                    <Footers inv={inv} />
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <div className="contentview">
                        <HeadersNew found={found} sta={sta} locInv={locInv} />
                        <BodyInvoice chunk={page ?? []} />
                        </div>
                        <Footers inv={inv} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default DeleveryNotesPrint;
